import React from 'react';
import JobDetailsContainer from '../../Componant/JobSearch/JobDetail';

const JobDetails = () => {
  return (
    <div className='page-body'>
      <JobDetailsContainer />
    </div>
  );
};

export default JobDetails;
